import clsx, { type ClassArray } from "clsx"
import { twMerge } from "tailwind-merge"

// A dark twin looks like `dark:text-gunmetal-base-dark` (optionally with state
// variants and a trailing `!`) and sits right after its light class.
const DARK_TWIN = /^dark:(?:[a-z-]+:)*[a-z]+-.+-dark!?$/

// twMerge can drop a light class that a later class overrides while keeping its
// `-dark` twin. A twin is only valid while its light partner (the token right
// before it) survives the merge, so drop twins whose partner was removed.
export function cn(...inputs: ClassArray) {
    const joined = clsx(inputs)
    const merged = twMerge(joined)
    if (!joined.includes("-dark")) return merged

    const tokens = joined.split(/\s+/).filter(Boolean)
    const kept = new Set(merged.split(/\s+/))
    const keepTwin = new Set<string>()
    const partnered = new Set<string>()
    tokens.forEach((token, i) => {
        if (!DARK_TWIN.test(token)) return
        const partner = tokens[i - 1]
        if (partner === undefined || DARK_TWIN.test(partner)) {
            keepTwin.add(token)
            return
        }
        partnered.add(token)
        if (kept.has(partner)) keepTwin.add(token)
    })

    const dropped = [...partnered].filter((twin) => !keepTwin.has(twin))
    if (dropped.length === 0) return merged
    const drop = new Set(dropped)
    return merged
        .split(/\s+/)
        .filter((token) => !drop.has(token))
        .join(" ")
}
